<h2 mat-dialog-title>Login Invalid</h2>
<mat-dialog-content>
    <p>The username and/or password you used is invalid. Please review your form entries and try again. If problem persists, please contact technical support.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
